import mimeType from '../constants/mime-type.ts';
import { degrees, PDFDocument } from 'pdf-lib';
import { FileToUpload } from '../types/FileToUpload.ts';
import exifr from 'exifr';

export default async (file: FileToUpload): Promise<FileToUpload> => {
    if (mimeType.pdf === file.file.type || !mimeType.images.includes(file.file.type)) {
        return file;
    }

    const imageBytes = new Uint8Array(await file.file.arrayBuffer());
    const pdf = await PDFDocument.create();
    const page = pdf.addPage();

    const pdfImage = mimeType.jpeg === file.file.type
        ? await pdf.embedJpg(imageBytes)
        : await pdf.embedPng(imageBytes);

    const imgRotation = await exifr.rotation(file.file);
    const isRotated = !!imgRotation?.deg;

    const widthRatio = page.getWidth() / (isRotated ? pdfImage.height : pdfImage.width);
    const heightRatio = page.getHeight() / (isRotated ? pdfImage.width : pdfImage.height);
    const scale = Math.min(widthRatio, heightRatio);
    const dimensions = pdfImage.scale(scale);

    page.drawImage(pdfImage, {
        x: (page.getWidth() - (isRotated ? dimensions.height : dimensions.width)) / 2,
        y: (page.getHeight() + (isRotated ? dimensions.width : -dimensions.height)) / 2,
        width: dimensions.width,
        height: dimensions.height,
        rotate: degrees(-(imgRotation?.deg || 0)),
    });

    file.file = new File([ await pdf.save() ], file.filename, { type: mimeType.pdf });

    return file;
}
